/**
 * Append `pbid=<clickId>` to an outbound affiliate URL so a partner postback
 * can echo it back and join the conversion to this exact click (Phase 4 ROI
 * loop). `pbid` is Accesstrade's auto-returned sub-id; partners that don't
 * support it simply ignore the extra query param, so it is safe to add
 * universally.
 *
 * Deliberately dependency-free (no React/posthog imports): shared by the
 * client `<AffiliateLink>` (`src/components/affiliate/affiliate-link.tsx`,
 * which re-exports this) AND the server-side `/[locale]/go/[offer]` redirect
 * route. A Route Handler importing straight from the "use client"
 * affiliate-link module would drag its posthog-js module graph into the SSR
 * worker bundle — see the "client-only heavy libs leaking into the SSR
 * server bundle" rule in CLAUDE.md.
 */
export function appendPbid(href: string, clickId: string | null): string {
	if (!clickId) return href;
	// Never touch non-http(s) targets (e.g. mailto:, tel:, in-app routes).
	if (!/^https?:\/\//i.test(href)) return href;
	const sep = href.includes("?") ? "&" : "?";
	return `${href}${sep}pbid=${encodeURIComponent(clickId)}`;
}
